import { DeleteTimeFrameRangeBulkInput, DeleteTimeFrameRangeBulkResponse, DeleteTimeFrameRangeInput } from '@/models/gen/graphql';

import { DeleteTimeFrameRangeBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import graphApi from '@/api';
import { handleError } from '@/utils';

type DeleteTimeFrameRangeBulkGraphApiResponse = GraphApiResponse<typeof DeleteTimeFrameRangeBulkDocument>;

const title = 'Delete Time Frame Ranges';

const deleteTimeFrameRangeBulkResponseSelector = (res: DeleteTimeFrameRangeBulkGraphApiResponse): DeleteTimeFrameRangeBulkResponse =>
  !res.errors ? res?.deleteTimeFrameRangeBulk : undefined;

const [runDeleteTimeFrameRangeBulk] = graphApi(DeleteTimeFrameRangeBulkDocument, {
  onError: (res: DeleteTimeFrameRangeBulkGraphApiResponse): void => handleError(res, { notification: { title } }),
});

const deleteTimeFrameRangeBulk = async (ids: string[]): Promise<DeleteTimeFrameRangeBulkResponse> => {
  const input: DeleteTimeFrameRangeBulkInput = { search: ids.map((id: string): DeleteTimeFrameRangeInput => ({ id })) };
  const res = await runDeleteTimeFrameRangeBulk({ input });

  return deleteTimeFrameRangeBulkResponseSelector(res);
};

export default deleteTimeFrameRangeBulk;
